import React, { useEffect, useRef, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import SweetAlert from 'react-bootstrap-sweetalert';
import { wsUpdate } from 'services/WService';
import { FormControlLabel } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';

export default function AmountModal(props) {
  const documentCustomer = props.model;
  const { setAlert, hideAlert, classes, showNotify, reload, dataOrigin } = props;

  const [checkPay, setCheckPay] = useState(false);
  const [amount, setAmount] = useState('');
  const saved = useRef(false);

  // Cada vez que se abre, arranca con lo guardado en ese documento (no con lo del anterior)
  useEffect(() => {
    if (!documentCustomer.open) return;
    const hasConcept = documentCustomer.advance_payment === 'Y';
    setCheckPay(hasConcept);
    setAmount(hasConcept ? documentCustomer.SumApplied : '');
    saved.current = false;
  }, [documentCustomer]);

  const hideSave = (dataOrigin[0]?.state === '5' || dataOrigin[0]?.state === 'L') && documentCustomer?.DocStatus === 'C';

  // Hay cambios si se marcó o desmarcó "Concepto", o si cambió el monto
  const savedConcept = documentCustomer.advance_payment === 'Y';
  const hasChanges = checkPay !== savedConcept
    || (checkPay && parseFloat(amount) !== parseFloat(documentCustomer.SumApplied));

  // Con "Concepto" se guarda el monto digitado; sin "Concepto", 0
  async function save() {
    const sumApplied = checkPay ? parseFloat(amount) : 0;
    if (checkPay && !(sumApplied > 0 && sumApplied <= parseFloat(documentCustomer.DocTotal))) {
      showNotify(`El monto debe ser mayor a 0 y hasta S/ ${documentCustomer.DocTotal}`, 'error');
      return false;
    }

    const response = await wsUpdate('prog/sheet-document', documentCustomer.id, {
      SumApplied: sumApplied,
      advance_payment: checkPay ? 'Y' : 'N',
    });
    if (!response.success) {
      showNotify(response.message, 'error');
      return false;
    }

    saved.current = true;
    showNotify(response.message);
    reload();
    return true;
  }

  // Si se cierra con cambios sin guardar, pregunta antes de perderlos
  function confirmClose() {
    if (hideSave || saved.current || !hasChanges) return true;

    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title="¿Desea guardar los cambios?"
        onConfirm={async () => {
          hideAlert();
          if (await save()) props.setOpen({ open: false });
        }}
        onCancel={() => {
          hideAlert();
          props.setOpen({ open: false });
        }}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Guardar"
        cancelBtnText="No guardar"
        showCancel
      >
        {checkPay ? `Con concepto: S/ ${amount || 0}` : 'Sin concepto: el monto queda en 0'}
      </SweetAlert>
    );
    return false;
  }

  return (
    <Modal
      title={`Documento del cliente ${documentCustomer.CardName}`}
      model={documentCustomer}
      setOpen={props.setOpen}
      showNotify={showNotify}
      hideSave={hideSave}
      onSubmit={async () => {
        // Si no se guardó, el modal sigue abierto
        if (!(await save())) throw new Error('No se guardó');
      }}
      onCloseRequest={confirmClose}
    >
      <FormControlLabel fullWidth margin="normal" size="small"
        control={
          <Checkbox
            checked={checkPay}
            disabled={hideSave}
            onChange={(e) => setCheckPay(e.target.checked)}
          />
        }
        label="Concepto"
        classes={{ label: classes.titleCheckBox }}
      />
      <TextField
        label="Total documento"
        fullWidth
        name="SumApplied"
        margin="normal"
        type="number"
        disabled={!checkPay || hideSave}
        value={checkPay ? amount : 0}
        onChange={(e) => setAmount(e.target.value)}
        inputProps={{
          max: documentCustomer.DocTotal,
          min: 0,
          step: 0.01
        }}
      />
    </Modal>
  );
}
